import React from 'react';

import { Box, Typography } from '@material-ui/core';

import VyceLoader from '@vyce/core/src/components/VyceLoader';

import { COPY } from '../config';
import useStyles from '../styles';

interface Props {
  isCSCS: boolean;
}

export const ScanningOverlay = ({ isCSCS }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.overlay}>
      <VyceLoader size={140} />
      <Typography variant="h6" align="center">
        {isCSCS ? COPY.scanning.cscsTitle : COPY.scanning.qualificationTitle}
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        {COPY.scanning.subtitle}
      </Typography>
    </Box>
  );
};
